export default __webpack_public_path__ + "static/media/altehaasgroteskbold.51e503d8.ttf";